import SupportChat from "./support-chat.component";

export { openSupport } from "./support-chat.component";
export default SupportChat;
